import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/app.scss'
import {firestorePlugin} from 'vuefire'
import 'bootstrap'

Vue.config.productionTip = false
Vue.use(firestorePlugin)

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
